import { Button } from '../Button';
import { TextField } from '../TextField/Textfield';
import { FirstTimeSetupFormProps } from './types';
import classes from './SSOSettings.module.css';

export const FirstTimeSetupForm = ({
  formErrors,
  isEnabling,
  onSubmit,
  onCancel,
  isFieldRequired,
  t,
}: FirstTimeSetupFormProps) => (
  <div className={classes.formSection}>
    <div className={classes.formHeader}>
      <h3>{t('ssoSettings.setup.title', { defaultValue: 'Sett opp Microsoft Entra ID' })}</h3>
      <p className={classes.formDescription}>
        {t('ssoSettings.setup.description', { defaultValue: 'Fyll inn informasjonen fra din Entra ID app-registrering. Se instruksjonene nedenfor hvis du trenger hjelp.' })}
      </p>
    </div>

    <form onSubmit={onSubmit} className={classes.form}>
      <TextField
        label={t('ssoSettings.form.tenantId.label')}
        name="entraIdTenantId"
        type="text"
        placeholder={t('ssoSettings.form.tenantId.placeholder')}
        error={formErrors.entraIdTenantId}
        required={isFieldRequired('entraIdTenantId')}
      />
      <TextField
        label={t('ssoSettings.form.clientId.label')}
        name="entraIdClientId"
        type="text"
        placeholder={t('ssoSettings.form.clientId.placeholder')}
        error={formErrors.entraIdClientId}
        required={isFieldRequired('entraIdClientId')}
      />
      <TextField
        label={t('ssoSettings.form.clientSecret.label')}
        name="entraIdClientSecret"
        type="password"
        autoComplete="new-password"
        placeholder={t('ssoSettings.form.clientSecret.placeholder')}
        error={formErrors.entraIdClientSecret}
        required={isFieldRequired('entraIdClientSecret')}
      />
      <TextField
        label={t('ssoSettings.form.domain.label')}
        name="entraIdDomain"
        type="text"
        placeholder={t('ssoSettings.form.domain.placeholder')}
        error={formErrors.entraIdDomain}
      />

      <div className={classes.formActions}>
        <Button variant="success" size="medium" type="submit" disabled={isEnabling}>
          {isEnabling ? (
            <span className={classes.buttonLoading}>
              <span className={classes.buttonSpinner} />
              {t('ssoSettings.form.enabling')}
            </span>
          ) : (
            t('ssoSettings.form.enableButton')
          )}
        </Button>
        <Button variant="secondary" size="medium" onClick={onCancel} disabled={isEnabling}>
          {t('ssoSettings.form.cancelButton')}
        </Button>
      </div>
    </form>
  </div>
);
